import type React from 'react';
import { createContext, useContext, useState } from 'react';
import { type OfficeDataContextType } from './types';

export const OfficeDataContext = createContext<OfficeDataContextType>({
  isConnectSlide: false,
  setIsConnectSlide: () => {},
  sessionInfo: {},
  setSessionInfo: () => {},
  isStreamActive: false,
  setIsStreamActive: () => {}
});

export function OfficeDataProvider({ children }: { children: React.ReactNode }) {
  const [isConnectSlide, setIsConnectSlide] = useState(false);
  const [sessionInfo, setSessionInfo] = useState({});
  const [isStreamActive, setIsStreamActive] = useState(false);

  return (
    <OfficeDataContext.Provider
      value={{
        isConnectSlide,
        setIsConnectSlide,
        sessionInfo,
        setSessionInfo,
        isStreamActive,
        setIsStreamActive
      }}
    >
      {children}
    </OfficeDataContext.Provider>
  );
};

export const useOfficeData = () => useContext(OfficeDataContext);
